import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyL } from 'atoms/typography';
import { Video } from 'atoms/ui/Video';
import { FOOTBALL_RIVALS_LEAGUE_PRIZE_POOL } from 'constants/__generated__/routes';
import { navLabels } from 'lib/glossary';
import { Link } from 'routing/Link';

import poster from './assets/poster.jpg';

const Root = styled.header`
  position: relative;
  isolation: isolate;
`;
const Wrapper = styled.div`
  height: 90vh;
  background: linear-gradient(transparent, #121013);
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  padding-bottom: 10vmin;
  display: grid;
  grid-template-columns: 1fr fit-content(calc(100 * var(--unit))) 1fr;
  > * {
    grid-column: 2;
  }
`;

const Title = styled.h1`
  font-size: clamp(var(--fs-32), 8vw, 80px); /** 80 / 1920 * 100 = 4.16 */
  font-weight: normal;
`;

const StyledVideo = styled(Video)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

const StyledLink = styled(Link)`
  color: var(--c-brand-300);
  text-decoration: underline;
`;

type Props = {
  onCreate: (arg: unknown) => void;
};
export const RivalsLeaguesHeader = ({ onCreate }: Props) => {
  return (
    <Root>
      <StyledVideo
        sources={[
          {
            src: 'https://frontend-assets.sorare.com/videos/rivals_leagues-no_sound.mp4',
          },
        ]}
        autoPlay
        loop
        playsInline
        poster={poster}
      />
      <Wrapper>
        <Vertical gap={3}>
          <Title>
            <FormattedMessage
              id="RivalsLeaguesHeader.title"
              defaultMessage="Rivals Leagues"
            />
          </Title>
          <BodyL>
            <FormattedMessage
              id="RivalsLeaguesHeader.subtitle2"
              defaultMessage="You and your friends, against the world! Create your Rivals League for the European Championship, dominate each match day, and win <link>350,000+ rewards.</link>"
              values={{
                link: chunks => (
                  <StyledLink to={FOOTBALL_RIVALS_LEAGUE_PRIZE_POOL}>
                    {chunks}
                  </StyledLink>
                ),
              }}
            />
          </BodyL>
          <Horizontal center>
            <Button color="secondary" size="medium" onClick={onCreate}>
              <FormattedMessage
                id="RivalsLeaguesHeader.cta1"
                defaultMessage="Create your league"
              />
            </Button>
            <Button
              color="quaternary"
              size="medium"
              href="https://www.youtube.com/watch?v=kD8Z8T8-7kc"
              externalLink
            >
              <FormattedMessage
                id="RivalsLeaguesHeader.cta2"
                defaultMessage="Watch trailer"
              />
            </Button>
          </Horizontal>
          <Button
            color="transparent"
            size="large"
            to={FOOTBALL_RIVALS_LEAGUE_PRIZE_POOL}
          >
            <FormattedMessage {...navLabels.prizePool} />
          </Button>
        </Vertical>
      </Wrapper>
    </Root>
  );
};
